module.exports = __webpack_public_path__ + "img/Dixie article 1.3e87c904.jpg";